<template>
  <div class="col-md-10 col-lg-10 offset-md-1 offset-lg-1 page">
    <div class="page-help-corner">
      <help-icon help-id="vitals" title="Help for Vitals" />
    </div>
    <div class="link__container">
      <router-link :to="'/vitals'" class="item__link all">All</router-link>
      <router-link :to="getVitalsGrouping('glucose')" class="item__link glucose">Glucose</router-link>
      <router-link :to="getVitalsGrouping('pulse')" class="item__link pulse">BP</router-link>
      <router-link :to="getVitalsGrouping('weight')" class="item__link weight">Weight</router-link>
      <router-link :to="getVitalsGrouping('breathing')" class="item__link breathing">SpO<sub>2</sub></router-link>
      <router-link :to="getVitalsGrouping('temperature')" class="item__link temperature">Temp</router-link>
      <router-link :to="getVitalsGrouping('continual')" class="item__link continual">Continual</router-link>
    </div>

    <p class="mb-md-o mb-0">
      <small class="">
        <strong>
          Toggle <input type="checkbox" class="mr-1 mr-md-1" :checked="checked" @click="checked=!checked"/>to {{ graphOrUngraphMessage }}
        </strong>
      </small>
    </p>
    <vital-signs></vital-signs>

    <watch-graph></watch-graph>
      
    <!-- <watch-list :newestProcedure="procCcd"></watch-list> -->
      
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import WatchGraph from "./_partials/watch/Graph";
  import WatchList from "./_partials/watch/WatchList";
  import VitalSigns from "./_partials/watch/VitalSigns";
  import { 
    requestVitalSignsCodes
  } from '@/api/sessionApi';
  import {
    requestExternalMeasures
  } from '@/api/dataApi';
  import TogglableCaretHeader from '@/components/includes/TogglableCaretHeader';
import { h } from 'vue';
import HelpIcon from '@/components/help/HelpIcon.vue';

  export default {
    name: "vitals-page",
    props: {
      procCcd: {
        type: Number,
        default: 0
      }
    },
    components: {
      'watch-graph': WatchGraph, 
      'watch-list': WatchList,
      'vital-signs': VitalSigns,
      HelpIcon,
    },
    data() {
      return {
        checked: false
      }
    },
    computed: {
      graphOrUngraphMessage() {
        return this.checked?'ungraph':'graph'
      },
      ...mapGetters('login/watch', {
        measuresWatching: 'getMeasuresWatching',
        proceduresWatching: 'getProceduresWatching',
        checkedMeasures: 'getCheckedMeasures',
        vitalCcds: 'getVitalSignCodes',
        areExternalMeasuresLoaded: 'areExternalMeasuresLoaded'
      }),
      hasItemInWatchList() {
        return (this.measuresWatching && Object.keys(this.measuresWatching).length > 0)
        || (this.proceduresWatching && Object.keys(this.proceduresWatching).length > 0);
      }
    },
    methods: {
      ...mapActions('login/watch', [
        'setVitalSignCodes',
        'setExternalMeasuresLoaded'
      ]),
      ...mapActions('login', [
        'addMeasures'
      ]),
      getVitalsGrouping(group){
        return {
          name: "VitalsGroup",
          params: { grouping: group }
        }
      },
      handleExternalMeasures({externalMeasures,externalMeasCcdMeasIds,externalMeasCcds}) {
          this.addMeasures({externalMeasures,externalMeasCcdMeasIds,externalMeasCcds});
          this.setExternalMeasuresLoaded(true);
      }
    },
    mounted() {
      if (!this.vitalCcds || this.vitalCcds.length < 1) {
        requestVitalSignsCodes()
        .then((vitalSignCodes) => {
          this.setVitalSignCodes(vitalSignCodes);
        })
        .catch((err) => {
          console.error(err);
        });
      }
      // console.log(this.areExternalMeasuresLoaded)
      if (/*!this.areExternalMeasuresLoaded*/ true) {
        let loader = this.$loading.show({},{
            after: () => h('div',{},'Loading data...')
        });
        requestExternalMeasures()
        .then(this.handleExternalMeasures)
        .then(() => {
          loader.hide()
          loader = null
        })
        .catch((err) => {
          console.dir(err);
          // alert(err);
          loader.hide()
          loader = null
        });
      }
    },
    beforeDestroy() {
      delete this.graphOrUngraphMessage;
      delete this.hasItemInWatchList;
    }
  }
</script>

<style scoped lang="scss">

  .page {
    margin-bottom: 4.0rem;
  }
  .card-header {
    padding: 0.2rem;
    background-color: #fff;

    a {
      width: 100%;
      text-align: left;
    }
 }
  .card-body {
    padding: 0;
    font-size: 0.95rem;
  }

  .btn--remove {
    background-color: transparent;
    margin: 0;
    padding: 0;
    color: #ff4444;

    &:hover {
      color: #cc0000;
    }
  }

  .item__link {
    display: block;
    width: 100%;
    background-color: #49a5a7;
    color: #fff;
    font-size: 0.9em;
    border-radius: 3px;
    padding: 5px 0;
    text-align: center;
  }

  .all {
    background-color: #0c8687
  }

  .link__container {
    display: grid;
    grid-auto-flow: column;
    column-gap: 20px;
    margin-bottom: 10px;
    width: 100%;
  }

  .page-help-corner {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 0.35rem;
  }

</style>
